import { render } from "./AppParagraph.vue?vue&type=template&id=a715ee58&scoped=true"
import script from "./AppParagraph.vue?vue&type=script&lang=js"
export * from "./AppParagraph.vue?vue&type=script&lang=js"

import "./AppParagraph.vue?vue&type=style&index=0&id=a715ee58&scoped=true&lang=css"

import exportComponent from "/home/sergey/projects/tm/calc_furnace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a715ee58"]])

export default __exports__